/* ============================================================
   AURORA DESKTOP HEADER CONTROLLER — The Nine Aurora
   One coordinator for the four mega menus and the utility
   experiences (Search / Language / Favorites / Account / Cart).
   Non-modal disclosures per the approved brief: no dialog role,
   no focus trap, no body-scroll lock for the mega menus.
   ============================================================ */
(function () {
  'use strict';

  /* RULE (owner, 2026-07-19): the Shop recognition popup ("items saved for
     you while you were browsing" / floating "Continue with Shop" sheet)
     must NEVER appear. Suppress any floating Shop portal on every page and
     viewport. The Shop sign-in inside the account sheet is unaffected, and
     Shop Pay checkout buttons are explicitly exempt. */
  var SHOP_FRAME_RE = /shop\.app|shop-js|shopifycloud\/shop/i;
  var SHOP_TEXT_RE = /items?\s+saved\s+for\s+you\s+while\s+you\s+were\s+browsing|continue\s+with\s+shop\b/i;
  /* RULE (owner, 2026-07-19): the Shop "Sign in or create account" bottom
     sheet must ONLY ever appear as a direct response to a tap on the Aurora
     account capsule. Any Shop sign-in surface that shows up on its own
     (page load, scroll, exit intent) is removed. */
  var SHOP_SIGNIN_RE = /sign\s+in\s+or\s+create\s+account|continue\s+as\s+\S+[\s\S]{0,200}?\bshop\b|accedi\s+o\s+crea\s+un\s+account/i;
  /* The auto-sheet guard is MOBILE-ONLY: the desktop experience is locked
     to its approved state and this guard must never evaluate anything
     at >=1204px. */
  var mqlSignGuard = window.matchMedia('(max-width: 1203.98px)');
  var lastAccountTapTs = 0;
  function markAccountTap(e) {
    try {
      var path = (e.composedPath && e.composedPath()) || [];
      for (var pi = 0; pi < path.length; pi++) {
        var pe = path[pi];
        if (pe && pe.tagName === 'SHOPIFY-ACCOUNT') { lastAccountTapTs = Date.now(); return; }
      }
      if (e.target && e.target.closest && e.target.closest('shopify-account, .aurora-mhdr-signin-btn, [data-mtab="signin"], .aurora-mnav-view[data-mview="signin"]')) {
        lastAccountTapTs = Date.now();
      }
    } catch (err) { /* noop */ }
  }
  document.addEventListener('pointerdown', markAccountTap, true);
  document.addEventListener('click', markAccountTap, true);
  function accountTapRecent() { return Date.now() - lastAccountTapTs < 4000; }
  var shopObservedRoots = typeof WeakSet === 'function' ? new WeakSet() : null;

  function hideShopNode(n) {
    n.style.setProperty('display', 'none', 'important');
    n.style.setProperty('visibility', 'hidden', 'important');
    n.style.setProperty('pointer-events', 'none', 'important');
  }
  function shopSweep(rootNode) {
    if (!rootNode || !rootNode.querySelectorAll) return;
    var nodes = rootNode.querySelectorAll('*');
    for (var i = 0; i < nodes.length; i++) {
      var n = nodes[i];
      var t = n.tagName || '';
      /* Never touch the approved sign-in sheet or the Recharge cart drawer. */
      if (t === 'SHOPIFY-ACCOUNT') continue;
      if (n.closest && n.closest('shopify-account')) continue;
      if (n.shadowRoot) {
        if (!n.shadowRoot.querySelector('#cart-drawer') && t !== 'SHOPIFY-ACCOUNT') {
          if (shopObservedRoots && !shopObservedRoots.has(n.shadowRoot)) {
            shopObservedRoots.add(n.shadowRoot);
            try {
              new MutationObserver(function (sr) {
                return function () { shopSweep(sr); };
              }(n.shadowRoot)).observe(n.shadowRoot, { childList: true, subtree: true });
            } catch (err) { /* noop */ }
          }
          shopSweep(n.shadowRoot);
        }
        continue;
      }
      var isShopEl = t.indexOf('SHOP-') === 0 &&
                     t !== 'SHOP-PAY-BUTTON' && t !== 'SHOP-PAY-WALLET-BUTTON';
      var meta = (n.src || '') + ' ' + (n.name || '') + ' ' + (n.id || '') + ' ' +
                 (typeof n.className === 'string' ? n.className : '') + ' ' + (n.title || '');
      if (t === 'IFRAME' && n.parentElement) {
        /* shop-js often puts its identity on the iframe's WRAPPER, not the
           iframe itself — include the parent's id/class in the match. */
        meta += ' ' + (n.parentElement.id || '') + ' ' +
                (typeof n.parentElement.className === 'string' ? n.parentElement.className : '');
      }
      var isShopFrame = t === 'IFRAME' && SHOP_FRAME_RE.test(meta);
      if (isShopEl || isShopFrame) {
        hideShopNode(n);
        /* Also collapse fixed wrapper layers the portal sits in. */
        var p = n.parentElement;
        while (p && p !== document.body && p !== rootNode) {
          var pos = '';
          try { pos = getComputedStyle(p).position; } catch (err2) { pos = ''; }
          if (pos === 'fixed') hideShopNode(p);
          p = p.parentElement;
        }
        continue;
      }
      /* Last-resort: a fixed light-DOM overlay carrying the Shop prompt copy. */
      if (rootNode === document && (t === 'DIV' || t === 'SECTION' || t === 'ASIDE' || t === 'DIALOG')) {
        var fixed = false;
        try { fixed = getComputedStyle(n).position === 'fixed'; } catch (err3) { fixed = false; }
        if (fixed && !n.closest('.yomi-header-wrapper')) {
          var txt = n.textContent || '';
          if (SHOP_TEXT_RE.test(txt)) {
            hideShopNode(n);
          } else if (mqlSignGuard.matches && !n.hasAttribute('data-aurora-shop-decided') &&
                     SHOP_SIGNIN_RE.test(txt) &&
                     !n.querySelector('#cart-drawer') && !n.closest('.aurora-mnav')) {
            /* MOBILE ONLY (desktop is locked and must behave exactly as
               approved). Decide ONCE at first sight: a Shop sign-in sheet
               that appeared WITHOUT a tap on the account capsule is an
               auto-prompt and is removed; one that followed a tap is
               allowed and never re-examined (so an open sheet can never
               vanish later). */
            n.setAttribute('data-aurora-shop-decided', accountTapRecent() ? 'allowed' : 'removed');
            if (!accountTapRecent()) hideShopNode(n);
          }
        }
      }
    }
  }
  /* ---- Shop RECOGNITION popup ("N items saved for you while you were
     browsing" / Continue-with-Shop card) — owner report 2026-07-20: it
     appeared on desktop DESPITE the sweep, because the sweep deliberately
     never looks inside <shopify-account> (protecting the approved sign-in
     sheet) and skips the text check in shadow roots. This popup is rendered
     by the account component itself inside its shadow DOM. The recognition
     hunter below searches EVERY root, including shopify-account's shadow,
     keyed on the unique recognition copy, and hides only the overlay layer
     carrying it — the Sign in trigger and the tapped sign-in sheet contain
     no such copy and are never touched. */
  var SHOP_SAVED_RE = /items?\s+saved\s+for\s+you\s+while\s+you\s+were\s+browsing|articol\w*\s+salvat\w*\s+per\s+te\s+mentre\s+navigavi/i;
  var recogObservedRoots = typeof WeakSet === 'function' ? new WeakSet() : null;
  var recogHidden = []; /* overlays currently hidden by the hunter */
  function hideRecognitionOverlay(el, root) {
    /* Hide the OUTERMOST overlay layer (fixed/absolute/dialog) between the
       matched copy and this root; fall back to the matched element. The
       hide is REVERSIBLE: if the component later reuses the same layer for
       the legitimate sign-in sheet (copy changes), it is restored — so the
       hunter can never brick the approved sheet. */
    var target = null;
    var p = el;
    while (p && p !== root && p.nodeType === 1) {
      var pos = '';
      try { pos = getComputedStyle(p).position; } catch (e) { pos = ''; }
      var role = (p.getAttribute && p.getAttribute('role')) || '';
      if (pos === 'fixed' || pos === 'absolute' || role === 'dialog' ||
          (p.hasAttribute && p.hasAttribute('aria-modal')) || p.tagName === 'DIALOG') {
        target = p;
      }
      p = p.parentElement;
    }
    target = target || el;
    hideShopNode(target);
    for (var h = 0; h < recogHidden.length; h++) { if (recogHidden[h] === target) return; }
    recogHidden.push(target);
  }
  function restoreCleanOverlays() {
    for (var i = recogHidden.length - 1; i >= 0; i--) {
      var el = recogHidden[i];
      if (!el.isConnected || !SHOP_SAVED_RE.test(el.textContent || '')) {
        if (el.isConnected) {
          el.style.removeProperty('display');
          el.style.removeProperty('visibility');
          el.style.removeProperty('pointer-events');
        }
        recogHidden.splice(i, 1);
      }
    }
  }
  function recognitionSweep(root) {
    if (!root || !root.querySelectorAll) return;
    if (root === document) restoreCleanOverlays();
    var all = root.querySelectorAll('*');
    for (var i = 0; i < all.length; i++) {
      var n = all[i];
      if (n.shadowRoot) {
        if (recogObservedRoots && !recogObservedRoots.has(n.shadowRoot)) {
          recogObservedRoots.add(n.shadowRoot);
          try {
            new MutationObserver(function (sr) {
              return function () { recognitionSweep(sr); };
            }(n.shadowRoot)).observe(n.shadowRoot, { childList: true, subtree: true });
          } catch (err) { /* noop */ }
        }
        recognitionSweep(n.shadowRoot);
      }
      var txt = n.textContent || '';
      if (!SHOP_SAVED_RE.test(txt)) continue;
      /* smallest matching container: no child element carries the copy alone */
      var childMatches = false;
      for (var c = n.firstElementChild; c; c = c.nextElementSibling) {
        if (SHOP_SAVED_RE.test(c.textContent || '')) { childMatches = true; break; }
      }
      if (!childMatches) hideRecognitionOverlay(n, root);
    }
  }
  shopSweep(document);
  recognitionSweep(document);
  new MutationObserver(function () { shopSweep(document); recognitionSweep(document); })
    .observe(document.body, { childList: true, subtree: true });
  setInterval(function () { shopSweep(document); recognitionSweep(document); }, 1200);

  var root = document.querySelector('[data-aurora-header]');
  if (!root) return;

  var wrapper = root.closest('.yomi-header-wrapper') || root;
  var triggers = Array.prototype.slice.call(root.querySelectorAll('.aurora-nav-trigger[aria-controls]'));
  var scrim = document.getElementById('AuroraScrim');
  var mql = window.matchMedia('(min-width: 1204px)');
  var hoverFine = window.matchMedia('(hover: hover) and (pointer: fine)');
  var isHome = wrapper.classList.contains('aurora-mode--overlay');

  var OPEN_DELAY = 160;   /* within approved 140-180ms */
  var CLOSE_DELAY = 240;  /* within approved 180-300ms */
  var openTimer = null;
  var closeTimer = null;
  var current = null;     /* currently open trigger */

  function track(eventName, detail) {
    try {
      if (window.dataLayer && Array.isArray(window.dataLayer)) {
        var payload = { event: eventName, header_state: wrapper.classList.contains('aurora-is-scrolled') ? 'scrolled' : 'top', page_type: document.body.getAttribute('data-template') || document.body.className || 'unknown' };
        if (detail) { for (var k in detail) payload[k] = detail[k]; }
        window.dataLayer.push(payload);
      }
    } catch (e) { /* analytics must never break navigation */ }
  }

  function panelFor(trigger) {
    return document.getElementById(trigger.getAttribute('aria-controls'));
  }

  function setPanelFocusable(panel, focusable) {
    /* Closed panels must not contain focusable elements. */
    if ('inert' in panel) { panel.inert = !focusable; return; }
    var items = panel.querySelectorAll('a, button, [tabindex]');
    Array.prototype.forEach.call(items, function (el) {
      if (focusable) { el.removeAttribute('tabindex'); }
      else { el.setAttribute('tabindex', '-1'); }
    });
  }

  function closeMenu(returnFocus) {
    if (!current) return;
    var panel = panelFor(current);
    current.setAttribute('aria-expanded', 'false');
    if (panel) { panel.classList.remove('is-open'); setPanelFocusable(panel, false); }
    if (scrim) scrim.classList.remove('is-open');
    track('mega_menu_close', { menu_name: current.getAttribute('data-menu') });
    if (returnFocus) current.focus();
    current = null;
  }

  function openMenu(trigger) {
    if (current === trigger) return;
    if (current) closeMenu(false);
    var panel = panelFor(trigger);
    if (!panel) return;
    trigger.setAttribute('aria-expanded', 'true');
    panel.classList.add('is-open');
    setPanelFocusable(panel, true);
    if (scrim) scrim.classList.add('is-open');
    current = trigger;
    track('primary_nav_open', { menu_name: trigger.getAttribute('data-menu') });
  }

  function toggleMenu(trigger) {
    if (current === trigger) { closeMenu(true); } else { openMenu(trigger); }
  }

  /* ---------- Trigger wiring ---------- */
  triggers.forEach(function (trigger) {
    var item = trigger.closest('.aurora-nav-item') || trigger;
    var panel = panelFor(trigger);
    if (panel) setPanelFocusable(panel, false);

    trigger.addEventListener('click', function (e) {
      e.preventDefault();
      clearTimeout(openTimer); clearTimeout(closeTimer);
      toggleMenu(trigger);
    });

    trigger.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowDown') {
        e.preventDefault();
        openMenu(trigger);
        var first = panel && panel.querySelector('a, button');
        if (first) first.focus();
      }
    });

    if (hoverFine.matches) {
      var hoverZone = [item];
      if (panel) hoverZone.push(panel);
      hoverZone.forEach(function (zone) {
        zone.addEventListener('mouseenter', function () {
          clearTimeout(closeTimer);
          if (current === trigger) return;
          clearTimeout(openTimer);
          openTimer = setTimeout(function () { openMenu(trigger); }, OPEN_DELAY);
        });
        zone.addEventListener('mouseleave', function () {
          clearTimeout(openTimer);
          clearTimeout(closeTimer);
          closeTimer = setTimeout(function () {
            if (current === trigger) closeMenu(false);
          }, CLOSE_DELAY);
        });
      });
    }

    /* Keep open while focus is inside; close when it leaves both trigger and panel */
    var focusScope = [trigger];
    if (panel) focusScope.push(panel);
    focusScope.forEach(function (scope) {
      scope.addEventListener('focusout', function (e) {
        var next = e.relatedTarget;
        if (!next) return;
        var inside = focusScope.some(function (s) { return s.contains(next); });
        if (!inside && current === trigger) closeMenu(false);
      });
    });
  });

  /* Escape closes and returns focus to the trigger */
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && current) { closeMenu(true); }
  });

  /* Click outside closes */
  document.addEventListener('click', function (e) {
    if (!current) return;
    var panel = panelFor(current);
    if (current.contains(e.target)) return;
    if (panel && panel.contains(e.target)) return;
    closeMenu(false);
  });

  if (scrim) scrim.addEventListener('click', function () { closeMenu(false); });

  /* ---------- Utility coordination: opening any utility closes menus ---------- */
  var utilEvents = {
    'aurora-lang': 'language_open',
    'aurora-search': 'search_open',
    'aurora-favorites': 'favorites_open',
    'aurora-signin': 'account_open',
    'aurora-cart': 'cart_open'
  };
  Object.keys(utilEvents).forEach(function (id) {
    var el = document.getElementById(id);
    if (!el) return;
    el.addEventListener('click', function () {
      closeMenu(false);
      track(utilEvents[id], {});
    });
  });

  /* Cart: open the theme's cart drawer (Dawn <cart-drawer> element).
     Single listener; drawer handles Escape / overlay click / scroll lock. */
  /* Recharge drawer: close on outside click and Escape (the stripped outer
     panel is click-through, so we handle dismissal ourselves). */
  var rcHost = null;
  function rechargeHost() {
    if (rcHost && document.contains(rcHost) && rcHost.shadowRoot) return rcHost;
    rcHost = null;
    var nodes = document.body.querySelectorAll('*');
    for (var i = 0; i < nodes.length; i++) {
      if (nodes[i].shadowRoot && nodes[i].shadowRoot.querySelector('#cart-drawer')) { rcHost = nodes[i]; break; }
    }
    return rcHost;
  }
  function rechargeClose() {
    var host = rechargeHost();
    if (!host) return false;
    var sr = host.shadowRoot;
    var drawer = sr.querySelector('#cart-drawer');
    if (!drawer || !drawer.getClientRects().length) return false;
    var aurora = sr.querySelector('#aurora-cart-close');
    if (aurora) {
      /* Our injected button runs its own staged, animation-aware close chain
         with re-entrancy protection. Scheduling another trigger-toggle here
         raced against the exit animation and reopened the drawer — delegate
         entirely instead. */
      aurora.click();
      return true;
    }
    var closeBtn = sr.querySelector('#cart-drawer button[aria-label*="close" i]') ||
                   sr.querySelector('[role="dialog"] > button') ||
                   sr.querySelector('#cart-drawer > div:first-child button');
    if (closeBtn) closeBtn.click();
    /* Fallback path (no injected button yet): wait past the exit animation and
       only toggle when the drawer is verifiably still open */
    setTimeout(function () {
      var d2 = sr.querySelector('#cart-drawer');
      if (!d2 || !d2.getClientRects().length) return;
      var state = d2.closest('[data-state]');
      if (state && state.getAttribute('data-state') === 'closed') return;
      var trig = document.querySelector('[data-recharge-cart-trigger-observer]');
      if (trig) trig.click();
    }, 700);
    return true;
  }

  /* The X may render with a dead handler inside the capsule: any click on a
     button in the drawer header closes via our path. */
  document.addEventListener('click', function (e) {
    var host = rechargeHost();
    if (!host) return;
    var sr = host.shadowRoot;
    var drawer = sr.querySelector('#cart-drawer');
    if (!drawer || !drawer.getClientRects().length) return;
    var header = drawer.firstElementChild;
    if (!header) return;
    var path = e.composedPath ? e.composedPath() : [];
    for (var i = 0; i < path.length; i++) {
      var el = path[i];
      if (el && el.tagName === 'BUTTON' && header.contains(el)) {
        setTimeout(function () {
          var d2 = sr.querySelector('#cart-drawer');
          if (d2 && d2.getClientRects().length) {
            var trig = document.querySelector('[data-recharge-cart-trigger-observer]');
            if (trig) trig.click();
          }
        }, 200);
        break;
      }
    }
  });
  document.addEventListener('click', function (e) {
    var host = rechargeHost();
    if (!host) return;
    var drawer = host.shadowRoot.querySelector('#cart-drawer');
    if (!drawer || !drawer.getClientRects().length) return;
    var path = e.composedPath ? e.composedPath() : [];
    if (path.indexOf(drawer) !== -1) return;      /* click inside the capsule */
    var cartBtnEl = document.getElementById('aurora-cart');
    if (cartBtnEl && path.indexOf(cartBtnEl) !== -1) return; /* the toggle itself */
    rechargeClose();
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') rechargeClose();
  });

  /* Recharge drawer: 'Continue shopping' routes to the full catalogue */
  document.addEventListener('click', function (e) {
    var path = e.composedPath ? e.composedPath() : [];
    for (var i = 0; i < path.length; i++) {
      var el = path[i];
      if (el && el.tagName === 'BUTTON' && /continue\s+shopping/i.test(el.textContent || '')) {
        var rootNode = el.getRootNode && el.getRootNode();
        if (rootNode && rootNode.querySelector && rootNode.querySelector('#cart-drawer')) {
          window.location.href = '/collections/all-our-products';
        }
        break;
      }
    }
  });

  var cartButton = document.getElementById('aurora-cart');
  if (cartButton) {
    cartButton.addEventListener('click', function () {
      /* Recharge replaces the theme cart drawer on this store; prefer its
         trigger (same order the mobile header uses), then theme drawer. */
      var recharge = document.querySelector('[data-recharge-cart-trigger-observer]');
      if (recharge) { recharge.click(); return; }
      var drawer = document.querySelector('cart-drawer');
      if (drawer && typeof drawer.open === 'function') {
        drawer.open(cartButton);
      } else {
        window.location.href = '/cart';
      }
    });
  }

  /* Swym wishlist drawer: tag the full-height panel so CSS can reshape it
     into the shared capsule (owner request 2026-07-19). Detection is
     structural + textual, like the cart work: a fixed, right-anchored,
     tall panel mentioning the wishlist. */
  /* First-click race fix (owner report 2026-07-19): Swym builds the panel
     hidden at page load and opens it by mutating class/style, so childList
     observation plus a slow interval tagged it only after the first
     slide-in. Wishlist-intent clicks now trigger a rapid tagging burst,
     attribute mutations are observed, and during a short post-click window
     a panel still sliding in from the right also qualifies. */
  var wishlistIntentAt = 0;
  function wishlistPanelQualifies(node) {
    if (!node || node === document.body || node === document.documentElement) return false;
    if (node.closest && node.closest('.yomi-header-wrapper')) return false;
    var cs;
    try { cs = getComputedStyle(node); } catch (err) { return false; }
    /* Swym often nests the visual panel (absolute) inside a fixed overlay */
    if (cs.position !== 'fixed' && cs.position !== 'absolute') return false;
    if (cs.display === 'none' || cs.visibility === 'hidden') return false;
    var r = node.getBoundingClientRect();
    if (r.width < 300 || r.width > 1000) return false;
    if (r.height < window.innerHeight * 0.6) return false;
    var gap = window.innerWidth - r.right;
    if (gap > 80) return false; /* not right-anchored */
    /* Off-screen right is allowed only while an open is in flight —
       otherwise never risk forcing a slid-away panel visible */
    var openInFlight = Date.now() - wishlistIntentAt < 3000;
    if (gap < -4 && !openInFlight) return false;
    return true;
  }
  /* The capsule sits 28px in from the edge, but Swym's slide-away travels
     only the panel's own width — a 28px sliver would stay on screen after
     closing. When the slide-out settles with almost nothing on screen the
     panel hides itself; any new wishlist intent un-hides it first so the
     open animation is never suppressed. */
  function wishlistSettle(e) {
    var p = e && e.target && e.target.closest ? e.target.closest('.aurora-wishlist-capsule') : null;
    if (!p) return;
    var overlap = window.innerWidth - p.getBoundingClientRect().left;
    if (overlap <= 40) {
      p.style.setProperty('visibility', 'hidden', 'important');
    } else {
      p.style.removeProperty('visibility');
    }
  }
  function adoptWishlistPanel(node) {
    node.classList.add('aurora-wishlist-capsule');
    if (!node.getAttribute('data-aurora-wl-bound')) {
      node.setAttribute('data-aurora-wl-bound', '1');
      node.addEventListener('transitionend', wishlistSettle);
    }
  }
  function tagWishlistPanel() {
    if (!mql.matches) return;
    /* Primary: climb from any Swym-marked node to its visual panel */
    var swymNodes = document.body.querySelectorAll('[class*="swym" i], [id*="swym" i]');
    var found = false;
    for (var i = 0; i < swymNodes.length; i++) {
      var node = swymNodes[i];
      for (var d = 0; node && d < 8; d++, node = node.parentElement) {
        if (node.classList && node.classList.contains('aurora-wishlist-capsule')) { found = true; break; }
        if (wishlistPanelQualifies(node)) {
          adoptWishlistPanel(node);
          found = true;
          break;
        }
      }
    }
    if (found) return;
    /* Text fallback is expensive — only within the post-click window */
    if (Date.now() - wishlistIntentAt > 3000) return;
    var els = document.body.querySelectorAll('div, aside, section');
    for (var j = 0; j < els.length; j++) {
      var el = els[j];
      if (el.classList.contains('aurora-wishlist-capsule')) continue;
      if (!/wishlist/i.test(el.textContent || '')) continue;
      if (wishlistPanelQualifies(el)) adoptWishlistPanel(el);
    }
  }
  var wishlistTagRaf = null;
  function scheduleWishlistTag() {
    if (wishlistTagRaf) return;
    wishlistTagRaf = requestAnimationFrame(function () {
      wishlistTagRaf = null;
      tagWishlistPanel();
    });
  }
  document.addEventListener('click', function (e) {
    var t = e.target;
    if (!t || !t.closest) return;
    if (t.closest('#aurora-favorites, [class*="swym" i], [id*="swym" i], [aria-label*="wishlist" i], [href*="wishlist" i]')) {
      wishlistIntentAt = Date.now();
      var delays = [40, 120, 250, 500, 900];
      for (var i = 0; i < delays.length; i++) setTimeout(tagWishlistPanel, delays[i]);
    }
  }, { capture: true });
  new MutationObserver(function (muts) {
    /* Swym opens/closes by toggling classes: a class mutation touching the
       tagged panel is the open signal that clears the self-hidden state
       before the slide-in plays. Style mutations are ignored here so the
       settle-hide (an inline style write) cannot un-hide itself. */
    for (var i = 0; i < muts.length; i++) {
      var m = muts[i];
      if (m.type === 'attributes' && m.attributeName !== 'class') continue;
      var t = m.target;
      if (!t || t.nodeType !== 1) continue;
      var cap = (t.closest && t.closest('.aurora-wishlist-capsule')) ||
                (t.querySelector && t.querySelector('.aurora-wishlist-capsule'));
      if (cap && cap.style.visibility === 'hidden') cap.style.removeProperty('visibility');
    }
    scheduleWishlistTag();
  }).observe(document.body, { childList: true, subtree: true, attributes: true, attributeFilter: ['class', 'style'] });
  setInterval(tagWishlistPanel, 1200);
  tagWishlistPanel();

  /* Language / currency modal (Transcy popup or theme snippet): tag the
     dialog so CSS can restyle it into the Aurora capsule language
     (owner request 2026-07-19). Detected structurally: a visible box
     mentioning both language and currency. The OUTERMOST qualifying box
     (Transcy's white shell holding the close button and the Apply strip)
     becomes the capsule so those controls inherit the shared styling;
     nested qualifying boxes are flattened to transparent. Anything
     covering ~the whole viewport is the dim backdrop and never tagged. */
  /* The capsule is 420px wide (wishlist-sized); Transcy lays options out
     in a multi-column grid sized for its huge dialog, so collapse every
     grid inside to a single column. Re-run on every mutation because
     Transcy re-renders the list when the search box filters it. */
  function flattenLocaleGrids(rootEl) {
    var all = rootEl.querySelectorAll('*');
    for (var i = 0; i < all.length; i++) {
      var d;
      try { d = getComputedStyle(all[i]).display; } catch (err) { continue; }
      if (d === 'grid' || d === 'inline-grid') {
        all[i].style.setProperty('grid-template-columns', '1fr', 'important');
      }
    }
  }
  /* First-open flash fix (owner report 2026-07-19): Transcy inserts its
     raw white dialog and fills the content asynchronously, so the strict
     both-texts qualification can't match for a beat and the unstyled
     modal flashed. During a short intent window after a switcher click,
     anything that merely LOOKS like the locale dialog (fixed/absolute,
     plausible size, mentions language OR currency) is hidden before
     paint; adoption reveals it as the capsule, and a safety expiry
     restores anything hidden by mistake. */
  var localeIntentAt = 0;
  var localeSeenBefore = null;
  function snapshotLocaleDom() {
    /* Everything already in the DOM at click time is immune to the
       pre-hide — only elements Transcy creates AFTER the click can be
       curtained, so no pre-existing UI is ever touched. */
    localeSeenBefore = typeof WeakSet === 'function' ? new WeakSet() : null;
    if (!localeSeenBefore) return;
    var nodes = document.body.querySelectorAll('div, section, dialog');
    for (var i = 0; i < nodes.length; i++) localeSeenBefore.add(nodes[i]);
  }
  function preHideLocaleCandidates() {
    if (!mql.matches) return;
    if (Date.now() - localeIntentAt > 3000) return;
    var nodes = document.body.querySelectorAll('div, section, dialog');
    for (var i = 0; i < nodes.length; i++) {
      var el = nodes[i];
      if (el.classList.contains('aurora-locale-capsule') ||
          el.hasAttribute('data-aurora-loc-prehide') ||
          el.hasAttribute('data-aurora-loc-cleared') ||
          el.closest('.aurora-locale-capsule') ||
          el.closest('.yomi-header-wrapper')) continue;
      if (el.closest('[class*="swym" i], [id*="swym" i], #cart-drawer, [class*="recharge" i], [id*="recharge" i], shopify-account')) continue;
      var txt = el.textContent || '';
      var hasLocaleText = /language|lingua|currenc|valuta/i.test(txt);
      if (localeSeenBefore && !localeSeenBefore.has(el)) {
        /* Brand-new overlay since the click: Transcy's dialog often
           arrives as an EMPTY white box whose content loads later, so
           no text is required — but a new box already full of unrelated
           text is left alone. */
        if (!hasLocaleText && txt.replace(/\s+/g, '').length >= 40) continue;
      } else if (!hasLocaleText) {
        continue;
      }
      var r = el.getBoundingClientRect();
      if (r.width < 320 || r.width > 1300) continue;
      if (r.height < 120 || r.height > window.innerHeight + 4) continue;
      if (r.width >= window.innerWidth * 0.95 && r.height >= window.innerHeight * 0.95) continue;
      var cs;
      try { cs = getComputedStyle(el); } catch (err) { continue; }
      if (cs.position !== 'fixed' && cs.position !== 'absolute') continue;
      if (cs.display === 'none' || cs.visibility === 'hidden') continue;
      el.setAttribute('data-aurora-loc-prehide', String(Date.now()));
      el.style.setProperty('visibility', 'hidden', 'important');
      /* Every hide schedules its own restore, so a mistakenly curtained
         element comes back even if no click/interval fires afterwards. */
      setTimeout(releaseLocalePrehide, 2600);
    }
  }
  function releaseLocalePrehide(scope, force) {
    var hidden = (scope || document).querySelectorAll('[data-aurora-loc-prehide]');
    for (var i = 0; i < hidden.length; i++) {
      var el = hidden[i];
      var adopted = el.classList.contains('aurora-locale-capsule') || el.closest('.aurora-locale-capsule');
      var stale = Date.now() - Number(el.getAttribute('data-aurora-loc-prehide')) > 2500;
      if (adopted || stale || force) {
        el.style.removeProperty('visibility');
        el.removeAttribute('data-aurora-loc-prehide');
        /* Once restored, never re-curtain this element until the next
           switcher click — breaks any hide/restore loop. */
        if (!adopted) el.setAttribute('data-aurora-loc-cleared', '1');
      }
    }
  }
  /* Definitive kill (owner instruction 2026-07-19: "delete the old one
     completely — only the new one should remain"): Transcy's dialog can
     sit in the DOM *hidden* from page load and open via a visibility
     flip, which no insertion-watcher can catch in time. So the dialog is
     adopted IN ADVANCE while still hidden — geometry is unavailable for
     hidden nodes, so qualification is: both locale texts, a computed
     position of fixed/absolute (declared styles still compute when
     hidden), not one of our own surfaces. The deepest such node is the
     dialog box (its full-screen backdrop is shallower). By the time it
     is ever shown, it IS the capsule. */
  function preAdoptHiddenLocale() {
    if (!mql.matches) return;
    if (document.querySelector('.aurora-locale-capsule')) return;
    var nodes = document.body.querySelectorAll('div, section, dialog');
    var cands = [];
    for (var i = 0; i < nodes.length; i++) {
      var el = nodes[i];
      if (el.closest('.yomi-header-wrapper')) continue;
      if (el.id === 'localization-overlay' || el.closest('#localization-overlay')) continue;
      if (el.closest('[class*="swym" i], [id*="swym" i], #cart-drawer, [class*="recharge" i], [id*="recharge" i], shopify-account')) continue;
      var txt = el.textContent || '';
      if (!/language|lingua/i.test(txt)) continue;
      if (!/currenc|valuta/i.test(txt)) continue;
      var cs;
      try { cs = getComputedStyle(el); } catch (err) { continue; }
      if (cs.position !== 'fixed' && cs.position !== 'absolute') continue;
      cands.push(el);
    }
    var deepest = null;
    for (var j = 0; j < cands.length; j++) {
      var containsOther = false;
      for (var k = 0; k < cands.length; k++) {
        if (k !== j && cands[j].contains(cands[k])) { containsOther = true; break; }
      }
      if (!containsOther) { deepest = cands[j]; break; }
    }
    if (!deepest) return;
    deepest.classList.add('aurora-locale-capsule');
    var innerBoxes = deepest.querySelectorAll('div, section');
    for (var m = 0; m < innerBoxes.length; m++) {
      var itxt = innerBoxes[m].textContent || '';
      if (/language|lingua/i.test(itxt) && /currenc|valuta/i.test(itxt)) {
        innerBoxes[m].classList.add('aurora-locale-inner');
      }
    }
    flattenLocaleGrids(deepest);
    releaseLocalePrehide();
  }
  function tagLocaleModal() {
    if (!mql.matches) return;
    var existing = document.querySelector('.aurora-locale-capsule');
    if (existing) { flattenLocaleGrids(existing); releaseLocalePrehide(); return; }
    var nodes = document.body.querySelectorAll('div, section, dialog');
    var cands = [];
    for (var i = 0; i < nodes.length; i++) {
      var el = nodes[i];
      if (el.closest('.yomi-header-wrapper')) continue;
      var txt = el.textContent || '';
      if (!/language|lingua/i.test(txt)) continue;
      if (!/currenc|valuta/i.test(txt)) continue;
      var r = el.getBoundingClientRect();
      if (r.width < 320 || r.width > 1300) continue;
      if (r.height < 220 || r.height > window.innerHeight + 4) continue;
      if (r.width >= window.innerWidth * 0.95 && r.height >= window.innerHeight * 0.95) continue;
      var cs;
      try { cs = getComputedStyle(el); } catch (err) { continue; }
      /* Elements hidden by our own flash pre-hide still qualify — the
         hide is temporary and adoption is what reveals them. */
      var preHidden = el.hasAttribute('data-aurora-loc-prehide') ||
        (el.closest && el.closest('[data-aurora-loc-prehide]'));
      if (!preHidden && (cs.display === 'none' || cs.visibility === 'hidden')) continue;
      cands.push(el);
    }
    var outer = null;
    for (var j = 0; j < cands.length; j++) {
      var contained = false;
      for (var k = 0; k < cands.length; k++) {
        if (k !== j && cands[k].contains(cands[j])) { contained = true; break; }
      }
      if (!contained) { outer = cands[j]; break; }
    }
    if (!outer) return;
    outer.classList.add('aurora-locale-capsule');
    for (var m = 0; m < cands.length; m++) {
      if (cands[m] !== outer && outer.contains(cands[m])) {
        cands[m].classList.add('aurora-locale-inner');
      }
    }
    flattenLocaleGrids(outer);
    releaseLocalePrehide();
  }
  var localeTagRaf = null;
  function scheduleLocaleTag() {
    if (localeTagRaf) return;
    localeTagRaf = requestAnimationFrame(function () {
      localeTagRaf = null;
      preAdoptHiddenLocale();
      tagLocaleModal();
    });
  }
  document.addEventListener('click', function (e) {
    var t = e.target;
    if (!t || !t.closest) return;
    if (t.closest('#aurora-lang, [class*="transcy" i], [id*="transcy" i]')) {
      localeIntentAt = Date.now();
      var cleared = document.querySelectorAll('[data-aurora-loc-cleared]');
      for (var c = 0; c < cleared.length; c++) cleared[c].removeAttribute('data-aurora-loc-cleared');
      snapshotLocaleDom();
      preAdoptHiddenLocale();
      preHideLocaleCandidates();
      var delays = [40, 120, 250, 500, 900, 1500, 2200, 3000];
      for (var i = 0; i < delays.length; i++) {
        setTimeout(function () { preAdoptHiddenLocale(); preHideLocaleCandidates(); tagLocaleModal(); releaseLocalePrehide(); }, delays[i]);
      }
    }
  }, { capture: true });
  new MutationObserver(function () {
    /* Pre-hide synchronously (before paint) so the raw dialog never
       flashes; the rAF-throttled tagger then adopts and reveals it.
       Attribute changes are watched too: a hidden pre-existing dialog
       opened via a class/style flip must adopt in the same tick. */
    if (Date.now() - localeIntentAt < 3000) { preAdoptHiddenLocale(); preHideLocaleCandidates(); }
    scheduleLocaleTag();
  }).observe(document.body, { childList: true, subtree: true, attributes: true, attributeFilter: ['class', 'style', 'hidden'] });
  setInterval(function () { preAdoptHiddenLocale(); tagLocaleModal(); releaseLocalePrehide(); }, 1500);
  preAdoptHiddenLocale();

  /* Brand guard: "The Nine Aurora Beauty Zones" must NEVER be translated,
     in any language (owner rule 2026-07-19 — Transcy was rendering it as
     "Le nove zone di bellezza dell'aurora boreale"). Two layers, running
     on ALL viewports since the brand name matters on mobile too:
     1) any element whose text contains the English brand phrase is marked
        translate="no" + notranslate so Transcy's dynamic translator skips
        it before it ever translates;
     2) if a known machine-translation corruption (northern-lights
        phrasing) appears anyway, the text is restored to the brand name
        and the element is locked. */
  var BRAND_NAME = 'The Nine Aurora Beauty Zones';
  var BRAND_RX = /nine\s+aurora/i;
  var BRAND_BROKEN = [
    /le\s+nove\s+zone\s+di\s+bellezza\s+dell['’]\s?aurora(\s+boreale)?/gi,
    /les\s+neuf\s+zones\s+de\s+beauté\s+(?:de\s+l['’]\s?|des\s+)aurores?\s+boréales?/gi,
    /las\s+nueve\s+zonas\s+de\s+belleza\s+de\s+la\s+aurora\s+boreal/gi,
    /die\s+neun\s+schönheitszonen\s+(?:des\s+|der\s+)?(?:polar|nord)lichte?s?/gi
  ];
  function brandGuardSweep() {
    var body = document.body;
    if (!body) return;
    var walker = document.createTreeWalker(body, NodeFilter.SHOW_TEXT, null);
    var node;
    while ((node = walker.nextNode())) {
      var txt = node.nodeValue;
      if (!txt || txt.length < 10) continue;
      var parent = node.parentElement;
      if (!parent) continue;
      var tag = parent.tagName;
      if (tag === 'SCRIPT' || tag === 'STYLE' || tag === 'NOSCRIPT' || tag === 'TEXTAREA') continue;
      if (BRAND_RX.test(txt)) {
        if (!parent.hasAttribute('data-aurora-brand-guard')) {
          parent.setAttribute('data-aurora-brand-guard', '1');
          parent.setAttribute('translate', 'no');
          parent.classList.add('notranslate');
        }
        continue;
      }
      for (var b = 0; b < BRAND_BROKEN.length; b++) {
        BRAND_BROKEN[b].lastIndex = 0;
        if (BRAND_BROKEN[b].test(txt)) {
          BRAND_BROKEN[b].lastIndex = 0;
          node.nodeValue = txt.replace(BRAND_BROKEN[b], BRAND_NAME);
          parent.setAttribute('data-aurora-brand-guard', '1');
          parent.setAttribute('translate', 'no');
          parent.classList.add('notranslate');
          break;
        }
      }
    }
  }
  var brandGuardRaf = null;
  function scheduleBrandGuard() {
    if (brandGuardRaf) return;
    brandGuardRaf = requestAnimationFrame(function () {
      brandGuardRaf = null;
      brandGuardSweep();
    });
  }
  new MutationObserver(scheduleBrandGuard)
    .observe(document.documentElement, { childList: true, subtree: true, characterData: true });
  brandGuardSweep();
  setInterval(brandGuardSweep, 2000);

  /* Destination + CTA analytics via delegation */
  root.addEventListener('click', function (e) {
    var a = e.target.closest && e.target.closest('a[href]');
    if (!a || !current) return;
    var menu = current.getAttribute('data-menu');
    var evt = 'mega_menu_destination_click';
    if (a.hasAttribute('data-skin-ai')) evt = 'skin_ai_cta_click';
    if (a.hasAttribute('data-loyalty')) evt = 'loyalty_cta_click';
    track(evt, { menu_name: menu, link_label: (a.textContent || '').trim().slice(0, 80), destination: a.getAttribute('href') });
  });

  /* ---------- Scrolled state: one IntersectionObserver sentinel ---------- */
  var sentinel = document.getElementById('AuroraScrollSentinel');
  var hideables = Array.prototype.slice.call(root.querySelectorAll('.aurora-util--hideable'));
  var hideTimer = null;

  function applyScrolled(scrolled) {
    /* Utilities stay persistent in every state (owner decision 2026-07-19). */
    wrapper.classList.toggle('aurora-is-scrolled', scrolled);
    hideables.forEach(function (el) {
      el.removeAttribute('hidden');
      el.removeAttribute('aria-hidden');
      if ('inert' in el) el.inert = false;
    });
  }

  /* Surface detection: keep the lighter pill over photography/dark surfaces,
     use the deeper pill over flat light content (owner rule 2026-07-19). */
  var surfaceRaf = null;
  function detectSurface() {
    surfaceRaf = null;
    if (!wrapper.classList.contains('aurora-is-scrolled')) { wrapper.classList.remove('aurora-pill--on-media'); return; }
    var onMedia = false;
    try {
      var els = document.elementsFromPoint(window.innerWidth / 2, 100);
      for (var i = 0; i < els.length; i++) {
        var el = els[i];
        if (wrapper.contains(el)) continue;
        var tag = el.tagName;
        if (tag === 'IMG' || tag === 'VIDEO' || tag === 'PICTURE' || tag === 'CANVAS') { onMedia = true; break; }
        var cs = getComputedStyle(el);
        if (cs.backgroundImage && cs.backgroundImage !== 'none') { onMedia = true; break; }
        var m = (cs.backgroundColor || '').match(/rgba?\(([\d.]+)[, ]+([\d.]+)[, ]+([\d.]+)(?:[,/ ]+([\d.]+))?\)/);
        if (m) {
          var a = m[4] === undefined ? 1 : parseFloat(m[4]);
          if (a > 0.5) {
            var lumin = 0.2126 * (+m[1]) + 0.7152 * (+m[2]) + 0.0722 * (+m[3]);
            onMedia = lumin < 150; /* dark solid surface: lighter pill still reads */
            break;
          }
        }
      }
    } catch (e) { onMedia = false; }
    wrapper.classList.toggle('aurora-pill--on-media', onMedia);
  }

  var lastScrolled = null;
  function checkScrolled() {
    if (!mql.matches) return;
    var y = window.scrollY || document.documentElement.scrollTop || 0;
    var scrolled = y > 48;
    if (scrolled !== lastScrolled) { lastScrolled = scrolled; applyScrolled(scrolled); }
    if (!surfaceRaf) surfaceRaf = requestAnimationFrame(detectSurface);
  }
  window.addEventListener('scroll', checkScrolled, { passive: true });
  checkScrolled();

  /* ---------- Measured geometry: announcement + header heights ---------- */
  var announce = document.querySelector('.yomi-announcement');
  var docStyle = document.documentElement.style;

  function measure() {
    docStyle.setProperty('--an-announce-h', (announce && announce.offsetParent !== null ? announce.offsetHeight : 0) + 'px');
    var capsule = root.querySelector('.aurora-capsule');
    if (capsule) docStyle.setProperty('--an-header-h', capsule.offsetHeight + 'px');
  }

  measure();
  if ('ResizeObserver' in window) {
    var ro = new ResizeObserver(measure);
    if (announce) ro.observe(announce);
    ro.observe(root);
  } else {
    window.addEventListener('resize', measure, { passive: true });
  }

  /* Keep the cart count in the capsule synchronized with the theme's updater */
  var capsuleCount = document.getElementById('AuroraCartCount');
  var bubble = document.getElementById('cart-icon-bubble');
  if (capsuleCount && bubble && 'MutationObserver' in window) {
    new MutationObserver(function () {
      var mch = (bubble.textContent || '').match(/\d+/);
      if (mch) capsuleCount.textContent = mch[0];
    }).observe(bubble, { childList: true, characterData: true, subtree: true });
  }

  /* ============ AURORA MOBILE NAV controller (<1204px) ============
     Floating glass tab bar + frosted panel (owner brief 2026-07-19).
     The hamburger is cloned to strip the legacy drawer's listeners, so
     the old full-screen drawer stays in the theme but never opens. */
  (function () {
    var mnav = document.getElementById('AuroraMNav');
    if (!mnav) return;
    /* Portal to <body>: the header wrapper's legacy will-change creates a
       containing block that would trap this fixed overlay. */
    if (mnav.parentElement !== document.body) document.body.appendChild(mnav);
    var mqlMobile = window.matchMedia('(max-width: 1203.98px)');
    var tabs = mnav.querySelectorAll('.aurora-mnav-tab');
    var views = mnav.querySelectorAll('.aurora-mnav-view');
    var openState = false;

    function mnavSelect(name) {
      for (var i = 0; i < tabs.length; i++) {
        var on = tabs[i].getAttribute('data-mtab') === name;
        tabs[i].classList.toggle('active', on);
        tabs[i].setAttribute('aria-selected', on ? 'true' : 'false');
      }
      for (var j = 0; j < views.length; j++) {
        views[j].classList.toggle('active', views[j].getAttribute('data-mview') === name);
      }
    }
    var mnavOpenScrollY = 0;
    function mnavOpen(name) {
      if (openState) return;
      openState = true;
      mnavOpenScrollY = window.scrollY;
      /* The menu opens BELOW the header row (logo / Sign in / cart stay
         visible). Measure the bar's current bottom edge — in-flow at the
         top of the page, floating glass pill when scrolled. */
      try {
        var mh = document.querySelector('.yomi-mobile-header');
        var hb = mh ? mh.getBoundingClientRect().bottom : 0;
        if (hb > 0 && hb < window.innerHeight * 0.5) {
          mnav.style.setProperty('--aurora-mnav-top', Math.round(hb) + 'px');
        } else {
          mnav.style.removeProperty('--aurora-mnav-top');
        }
      } catch (err) { /* noop */ }
      mnav.hidden = false;
      mnavSelect(name || 'shop');
      requestAnimationFrame(function () {
        requestAnimationFrame(function () { mnav.classList.add('open'); });
      });
      document.body.classList.add('aurora-mnav-lock');
      track('mobile_nav_open', { menu_name: name || 'shop' });
    }
    function mnavClose() {
      if (!openState) return;
      openState = false;
      mnav.classList.remove('open');
      document.body.classList.remove('aurora-mnav-lock');
      setTimeout(function () { if (!openState) mnav.hidden = true; }, 320);
      track('mobile_nav_close', {});
    }

    var burger = document.getElementById('yomi-mobile-menu-btn');
    if (burger) {
      var cleanBurger = burger.cloneNode(true);
      burger.parentNode.replaceChild(cleanBurger, burger);
      cleanBurger.addEventListener('click', function (e) {
        if (!mqlMobile.matches) return;
        e.preventDefault();
        e.stopPropagation();
        /* The legacy DOMContentLoaded script re-binds the old drawer via
           .onclick AFTER this listener registers — it, and anything else
           bound later, must never fire (owner: old menu appeared on close). */
        e.stopImmediatePropagation();
        if (openState) { mnavClose(); } else { mnavOpen('shop'); }
      });
      cleanBurger.onclick = null;
      /* If any late script still assigns .onclick, void it. */
      setTimeout(function () { cleanBurger.onclick = null; }, 0);
      document.addEventListener('DOMContentLoaded', function () { cleanBurger.onclick = null; });
      window.addEventListener('load', function () { cleanBurger.onclick = null; });
    }

    /* Sentinel: the legacy slide-in drawer is retired. If ANY code opens
       it, close it instantly and undo its body scroll-lock. */
    var legacyDrawer = document.getElementById('yomi-mobile-drawer');
    if (legacyDrawer) {
      var unlockLegacy = function () {
        if (legacyDrawer.classList.contains('active') || legacyDrawer.classList.contains('closing')) {
          legacyDrawer.classList.remove('active', 'closing');
        }
        if (document.body.classList.contains('yomi-menu-open')) {
          document.body.classList.remove('yomi-menu-open');
          document.body.style.top = '';
        }
      };
      unlockLegacy();
      try {
        new MutationObserver(unlockLegacy)
          .observe(legacyDrawer, { attributes: true, attributeFilter: ['class', 'style'] });
        new MutationObserver(unlockLegacy)
          .observe(document.body, { attributes: true, attributeFilter: ['class'] });
      } catch (err) { /* noop */ }
    }
    for (var t = 0; t < tabs.length; t++) {
      tabs[t].addEventListener('click', function () {
        mnavSelect(this.getAttribute('data-mtab'));
      });
    }
    var closers = mnav.querySelectorAll('[data-mnav-close]');
    for (var c = 0; c < closers.length; c++) {
      closers[c].addEventListener('click', mnavClose);
    }
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && openState) mnavClose();
    });
    /* Scrolling closes the menu (owner 2026-07-19, Seed reference): the
       page behind must never move under a stale open menu — the header
       capsule's scroll color-change happens unobstructed. Two paths:
       1) touch-drag anywhere outside the menu's own surfaces (iOS Safari
          ignores body overflow:hidden, so this is the real signal); */
    document.addEventListener('touchmove', function (e) {
      if (!openState) return;
      var t = e.target;
      if (t && t.closest && (t.closest('.aurora-mnav-panel') || t.closest('.aurora-mnav-bar'))) return;
      mnavClose();
    }, { passive: true, capture: true });
    /* 2) any actual page scroll while open (belt for platforms where the
       body lock fails or programmatic scrolls happen). */
    window.addEventListener('scroll', function () {
      if (openState && Math.abs(window.scrollY - mnavOpenScrollY) > 24) mnavClose();
    }, { passive: true });
    /* Navigating away from an open panel closes it (links load new pages,
       but bfcache restores can bring the open state back) */
    window.addEventListener('pageshow', function () {
      if (openState) { openState = false; mnav.classList.remove('open'); mnav.hidden = true; document.body.classList.remove('aurora-mnav-lock'); }
    });
  })();

  /* ============ MOBILE HEADER: scroll glass ============
     (owner brief 2026-07-19 v2) The bar is IN FLOW at the top — the hero
     starts flush beneath it by construction. After the visitor scrolls
     past it (>120px, beyond the bar itself) it returns as a floating
     glass pill; the threshold guarantees the detach never causes a
     visible content jump. */
  (function () {
    var mHeader = document.querySelector('.yomi-mobile-header');
    if (!mHeader) return;
    var mqlM = window.matchMedia('(max-width: 1203.98px)');
    var mTick = false;
    function mScroll() {
      if (mTick) return;
      mTick = true;
      requestAnimationFrame(function () {
        mTick = false;
        if (!mqlM.matches) { document.body.classList.remove('aurora-m-scrolled'); return; }
        document.body.classList.toggle('aurora-m-scrolled', window.scrollY > 120);
      });
    }
    window.addEventListener('scroll', mScroll, { passive: true });
    mScroll();
  })();
})();
